function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// FiltersBar.jsx
import React from "react";
import FilterDropdown from "../dropdowns/filter-dropdown";
import { MaterialMenu, ColorMenu, MaterialMenuTwo } from "../dropdowns/menus";
import { SelectedFilters } from "../dropdowns/selected-filters";
const INDUSTRY_OPTIONS = [{
  value: "residential",
  label: "Residential"
}, {
  value: "commercial",
  label: "Commercial"
}, {
  value: "senior-living",
  label: "Senior Living"
}];
const PRICE_OPTIONS = [{
  value: "300",
  label: "Greater Than $300"
}];
const FEATURES_OPTIONS = [{
  value: "casters",
  label: "Available with Casters"
}, {
  value: "leather",
  label: "Available in Leather"
}, {
  value: "commercial_grad",
  label: "Commercial-Grade"
}];
const COLLECTIONS_OPTIONS = [{
  value: "banks",
  label: "Banks"
}, {
  value: "beckett",
  label: "Beckett"
}, {
  value: "doice",
  label: "Doice"
}, {
  value: "featured_combinations",
  label: "Featured Combinations "
}, {
  value: "francis",
  label: "Francis"
}, {
  value: "gainsborough_chairs",
  label: "Gainsborough Chairs"
}, {
  value: "haven_reserve",
  label: "Haven Reserve"
}, {
  value: "kelly",
  label: "Kelly"
}, {
  value: "libby_langdon_for_fairfield",
  label: "Libby Langdon for Fairfield"
}, {
  value: "ready_to_ship_upholstery",
  label: "Ready to Ship Upholstery"
}, {
  value: "savannah",
  label: "Savannah"
}, {
  value: "the_leather_reserve",
  label: "The Leather Reserve"
}, {
  value: "washable_slipcovers",
  label: "Washable Slipcovers"
}];
const PRODUCTS_OPTIONS = [{
  value: "arm_chair",
  label: "Arm Chair"
}];
const WIDTHS_OPTIONS = [{
  value: "0-20",
  label: "0-20 inches"
}, {
  value: "20-50",
  label: "20-50 inches"
}];
const QUICK_OPTIONS = [{
  value: "new",
  label: "New Items"
}, {
  value: "inStock",
  label: "In Stock"
}];
const HEIGHTS_OPTIONS = [{
  value: "0-20",
  label: "0-20 inches"
}, {
  value: "20-50",
  label: "20-50 inches"
}];
const DEPTHS_OPTIONS = [{
  value: "0-20",
  label: "0-20 inches"
}, {
  value: "20-30",
  label: "20-30 inches"
}];
const ARM_HEIGHTS_OPTIONS = [{
  value: "0-20",
  label: "0-20 inches"
}, {
  value: "20-40",
  label: "20-40 inches"
}];
class FiltersBar extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "toggleValueOLD", (group, value) => {
      this.setState(prev => {
        const current = prev[group] || [];
        const exists = current.indexOf(value) !== -1;
        return {
          ...prev,
          [group]: exists ? current.filter(v => v !== value) : current.concat(value)
        };
      });
    });
    _defineProperty(this, "toggleValue", (group, value) => {
      this.setState(prev => {
        const current = prev[group] || [];
        const exists = current.indexOf(value) !== -1;
        const updatedGroup = exists ? current.filter(v => v !== value) : current.concat(value);
        const nextState = {
          ...prev,
          [group]: updatedGroup
        };
        if (typeof this.props.onFiltersChange === "function") {
          // pass the full filters object up to the parent
          this.props.onFiltersChange(nextState);
        }
        return nextState;
      });
    });
    _defineProperty(this, "clearGroup", group => {
      this.setState(prev => ({
        ...prev,
        [group]: []
      }));
    });
    _defineProperty(this, "clearAll", () => {
      this.setState({
        price: [],
        industry: [],
        // array of values
        features: [],
        // array of values
        quick: [],
        collections: [],
        products: [],
        widths: [],
        heights: [],
        depths: [],
        armHeights: []
      }, () => {
        this.props.onFiltersChange(this.state);
      });
    });
    _defineProperty(this, "handleRemoveChip", chip => {
      this.toggleValue(chip.group, chip.value);
    });
    _defineProperty(this, "onMoreLessFilters", () => {
      this.setState(prev => ({
        showMoreFilters: !prev.showMoreFilters
      }));
    });
    this.state = {
      price: [],
      industry: [],
      // array of values
      features: [],
      // array of values
      quick: [],
      collections: [],
      products: [],
      widths: [],
      heights: [],
      depths: [],
      armHeights: [],
      showMoreFilters: false

      // later: price, height, etc.
    };
  }
  getSelectedItems() {
    const {
      price,
      industry,
      features,
      quick,
      collections,
      products,
      heights,
      widths,
      depths,
      armHeights
    } = this.state;
    const chips = [];
    PRICE_OPTIONS.forEach(opt => {
      if (price.indexOf(opt.value) !== -1) {
        chips.push({
          id: `price:${opt.value}`,
          group: "price",
          value: opt.value,
          label: `Price: ${opt.label}`
        });
      }
    });
    INDUSTRY_OPTIONS.forEach(opt => {
      if (industry.indexOf(opt.value) !== -1) {
        chips.push({
          id: `industry:${opt.value}`,
          group: "industry",
          value: opt.value,
          label: `Industry: ${opt.label}`
        });
      }
    });
    FEATURES_OPTIONS.forEach(opt => {
      if (features.indexOf(opt.value) !== -1) {
        chips.push({
          id: `features:${opt.value}`,
          group: "features",
          value: opt.value,
          label: `Features: ${opt.label}`
        });
      }
    });
    QUICK_OPTIONS.forEach(opt => {
      if (quick.indexOf(opt.value) !== -1) {
        chips.push({
          id: `quick:${opt.value}`,
          group: "quick",
          value: opt.value,
          label: `Quick: ${opt.label}`
        });
      }
    });
    PRODUCTS_OPTIONS.forEach(opt => {
      if (products.indexOf(opt.value) !== -1) {
        chips.push({
          id: `product:${opt.value}`,
          group: "products",
          value: opt.value,
          label: `Product Type: ${opt.label}`
        });
      }
    });
    COLLECTIONS_OPTIONS.forEach(opt => {
      if (collections.indexOf(opt.value) !== -1) {
        chips.push({
          id: `collection:${opt.value}`,
          group: "collections",
          value: opt.value,
          label: `Collection: ${opt.label}`
        });
      }
    });
    WIDTHS_OPTIONS.forEach(opt => {
      if (widths.indexOf(opt.value) !== -1) {
        chips.push({
          id: `width:${opt.value}`,
          group: "widths",
          value: opt.value,
          label: `Width: ${opt.label}`
        });
      }
    });
    HEIGHTS_OPTIONS.forEach(opt => {
      if (heights.indexOf(opt.value) !== -1) {
        chips.push({
          id: `height:${opt.value}`,
          group: "heights",
          value: opt.value,
          label: `Height: ${opt.label}`
        });
      }
    });
    DEPTHS_OPTIONS.forEach(opt => {
      if (depths.indexOf(opt.value) !== -1) {
        chips.push({
          id: `depth:${opt.value}`,
          group: "depths",
          value: opt.value,
          label: `Depth: ${opt.label}`
        });
      }
    });
    ARM_HEIGHTS_OPTIONS.forEach(opt => {
      if (armHeights.indexOf(opt.value) !== -1) {
        chips.push({
          id: `arm_height:${opt.value}`,
          group: "armHeights",
          value: opt.value,
          label: `Arm Height: ${opt.label}`
        });
      }
    });
    return chips;
  }
  render() {
    const {
      features,
      quick,
      collections,
      products,
      heights,
      widths,
      depths,
      armHeights
    } = this.state;
    const chips = this.getSelectedItems();
    let state = this.state;
    let moreLessLabel = state.showMoreFilters ? "Less Filters" : "More Filters";
    let moreLessSymbol = state.showMoreFilters ? "-" : "+";
    let moreLessClass = state.showMoreFilters ? "ff-filter-minus" : "ff-filter-plus";
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "ff-filter-bar"
    }, /*#__PURE__*/React.createElement(FilterDropdown, {
      label: "Industry"
    }, ({
      close
    }) => /*#__PURE__*/React.createElement(MaterialMenu, {
      options: INDUSTRY_OPTIONS,
      selectedValues: industry,
      onToggle: value => this.toggleValue("industry", value)
    })), /*#__PURE__*/React.createElement(FilterDropdown, {
      label: "Price"
    }, ({
      close
    }) => /*#__PURE__*/React.createElement(MaterialMenu, {
      options: PRICE_OPTIONS,
      selectedValues: price,
      onToggle: value => this.toggleValue("price", value)
    })), /*#__PURE__*/React.createElement(FilterDropdown, {
      label: "Features"
    }, ({
      close
    }) => /*#__PURE__*/React.createElement(MaterialMenu, {
      options: FEATURES_OPTIONS,
      selectedValues: features,
      onToggle: value => this.toggleValue("features", value)
    })), /*#__PURE__*/React.createElement(FilterDropdown, {
      label: "Quick"
    }, ({
      close
    }) => /*#__PURE__*/React.createElement(MaterialMenu, {
      options: QUICK_OPTIONS,
      selectedValues: quick,
      onToggle: value => this.toggleValue("quick", value)
    })), /*#__PURE__*/React.createElement(FilterDropdown, {
      label: "Products"
    }, ({
      close
    }) => /*#__PURE__*/React.createElement(MaterialMenu, {
      options: PRODUCTS_OPTIONS,
      selectedValues: products,
      onToggle: value => this.toggleValue("products", value)
    })), /*#__PURE__*/React.createElement(FilterDropdown, {
      label: "Collections"
    }, ({
      close
    }) => /*#__PURE__*/React.createElement(MaterialMenuTwo, {
      options: COLLECTIONS_OPTIONS,
      selectedValues: collections,
      onToggle: value => this.toggleValue("collections", value)
    })), state.showMoreFilters && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FilterDropdown, {
      label: "Widths"
    }, ({
      close
    }) => /*#__PURE__*/React.createElement(MaterialMenu, {
      options: WIDTHS_OPTIONS,
      selectedValues: widths,
      onToggle: value => this.toggleValue("widths", value)
    })), /*#__PURE__*/React.createElement(FilterDropdown, {
      label: "Heights"
    }, ({
      close
    }) => /*#__PURE__*/React.createElement(MaterialMenu, {
      options: HEIGHTS_OPTIONS,
      selectedValues: heights,
      onToggle: value => this.toggleValue("heights", value)
    })), /*#__PURE__*/React.createElement(FilterDropdown, {
      label: "Depths"
    }, ({
      close
    }) => /*#__PURE__*/React.createElement(MaterialMenu, {
      options: DEPTHS_OPTIONS,
      selectedValues: depths,
      onToggle: value => this.toggleValue("depths", value)
    })), /*#__PURE__*/React.createElement(FilterDropdown, {
      label: "Arm Heights"
    }, ({
      close
    }) => /*#__PURE__*/React.createElement(MaterialMenu, {
      options: ARM_HEIGHTS_OPTIONS,
      selectedValues: armHeights,
      onToggle: value => this.toggleValue("armHeights", value)
    }))), /*#__PURE__*/React.createElement("div", {
      className: "ff-more-filters-button",
      onClick: this.onMoreLessFilters
    }, /*#__PURE__*/React.createElement("span", {
      className: "ff-more-filters-label"
    }, moreLessLabel), /*#__PURE__*/React.createElement("span", {
      className: moreLessClass
    }, moreLessSymbol))), /*#__PURE__*/React.createElement(SelectedFilters, {
      items: chips,
      onRemove: this.handleRemoveChip,
      onClearAll: this.clearAll
    }));
  }
}
export default FiltersBar;